const React = require('react')
const { FormattedMessage } = require('react-intl')

const people = [
  {
    heading: <FormattedMessage defaultMessage="Dooer - Sam Nurmi Bild 1" id="press.images.people.sam-nurmi" />,
    imageId: '136Jn8t8CjKzr6d9k6QAPS8GWo3srKQjv',
    alt: 'Dooer Sam Nurmi Bild 1',
  },
  {
    heading: <FormattedMessage defaultMessage="Dooer - Sam Nurmi Bild 2" id="press.images.people.sam-nurmi-wide" />,
    imageId: '111h6Ew3BNZwPnNA33O_FDy9_MZ4bxdzo',
    alt: 'Dooer Sam Nurmi Bild 2',
  },
]

const logos = [
  {
    heading: <FormattedMessage defaultMessage="Dooer - Logotyp" id="press.images.logos.dooer-icon" />,
    imageId: '1Zdr8PlLmFZEHoDTAr-O9ttbcAsYzCeY8',
    alt: 'Dooer logotyp',
  },
  {
    heading: <FormattedMessage defaultMessage="Dooer - Logotyp Square" id="press.images.logos.dooer-logo-square" />,
    imageId: '1VL0uVs-Ldg9kwKoB4hWF3KeUWm7VSBz8',
    alt: 'Dooer logotyp Square',
  },
]

const products = [
  {
    heading: <FormattedMessage defaultMessage="Dooer - Bokföring" id="press.images.products.dooer-accounting" />,
    imageId: '1iVFAYDBWdcJdCbaBs5KrdhvRXIEo1mww',
    alt: 'Dooer bokföring',
  },
  {
    heading: <FormattedMessage defaultMessage="Dooer - Bokföringssvit" id="press.images.products.dooer-billing" />,
    imageId: '1tleIAFcrSokZmMDFL_ozEH7-5AJICN4p',
    alt: 'Dooer bokföringssvit',
  },
  {
    heading: <FormattedMessage defaultMessage="Dooer - Fakturering" id="press.images.products.dooer-billing" />,
    imageId: '1kJvUK6foxmqY8TX-urU6JK30BcOYf9Ri',
    alt: 'Dooer fakturering',
  },
  {
    heading: <FormattedMessage defaultMessage="Dooer - Lön" id="press.images.products.dooer-billing" />,
    imageId: '1w1XOKpVyFfdYy4-RmX0fp0_bu7VocJUq',
    alt: 'Dooer lön',
  },
  {
    heading: <FormattedMessage defaultMessage="Dooer - Utlägg" id="press.images.products.dooer-billing" />,
    imageId: '1Of7vwRqgZsApve6WEPB_h8n4_-QMzh1m',
    alt: 'Dooer utlägg',
  },
]

const office = [
  {
    heading: (
      <FormattedMessage defaultMessage="Dooer - Västerås kontoret" id="press.images.office.dooer-office-westeras" />
    ),
    imageId: '1EKTAFbmY2m8jeZEmduBKpyk7SgnoViWe',
    alt: 'Dooer Västerås kontoret',
  },
]

module.exports = { people, logos, products, office }
